import React from 'react';
import { Mic, MicOff, Video, VideoOff, PhoneOff, MessageCircle, Users, Monitor, MonitorOff } from 'lucide-react';

const VideoControls = ({
  isMuted,
  isVideoOff,
  isScreenSharing,
  onToggleMic,
  onToggleVideo,
  onToggleScreenShare,
  onLeave,
  onToggleChat,
  onToggleParticipants,
  showChat,
  showParticipants
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 border-t border-gray-700 p-4 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-center space-x-4">
        {/* Microphone Toggle */}
        <button
          onClick={onToggleMic}
          className={`p-3 rounded-full transition-all ${
            isMuted
              ? 'bg-red-600 hover:bg-red-700 text-white'
              : 'bg-gray-700 hover:bg-gray-600 text-white'
          }`}
          title={isMuted ? 'Unmute' : 'Mute'}
        >
          {isMuted ? <MicOff size={24} /> : <Mic size={24} />}
        </button>

        {/* Video Toggle */}
        <button
          onClick={onToggleVideo}
          className={`p-3 rounded-full transition-all ${
            isVideoOff
              ? 'bg-red-600 hover:bg-red-700 text-white'
              : 'bg-gray-700 hover:bg-gray-600 text-white'
          }`}
          title={isVideoOff ? 'Turn on camera' : 'Turn off camera'}
          disabled={isScreenSharing}
        >
          {isVideoOff ? <VideoOff size={24} /> : <Video size={24} />}
        </button>

        {/* Screen Share Toggle */}
        <button
          onClick={onToggleScreenShare}
          className={`p-3 rounded-full transition-all ${
            isScreenSharing
              ? 'bg-blue-600 hover:bg-blue-700 text-white'
              : 'bg-gray-700 hover:bg-gray-600 text-white'
          }`}
          title={isScreenSharing ? 'Stop sharing screen' : 'Share screen'}
        >
          {isScreenSharing ? <MonitorOff size={24} /> : <Monitor size={24} />}
        </button>

        {/* Participants Toggle */}
        <button
          onClick={onToggleParticipants}
          className={`p-3 rounded-full transition-all ${
            showParticipants
              ? 'bg-blue-600 hover:bg-blue-700 text-white'
              : 'bg-gray-700 hover:bg-gray-600 text-white'
          }`}
          title="Participants"
        >
          <Users size={24} />
        </button>

        {/* Chat Toggle */}
        <button
          onClick={onToggleChat}
          className={`p-3 rounded-full transition-all ${
            showChat
              ? 'bg-blue-600 hover:bg-blue-700 text-white'
              : 'bg-gray-700 hover:bg-gray-600 text-white'
          }`}
          title="Chat"
        >
          <MessageCircle size={24} />
        </button>

        {/* Leave Button */}
        <button
          onClick={onLeave}
          className="p-3 rounded-full bg-red-600 hover:bg-red-700 text-white transition-all"
          title="Leave class"
        >
          <PhoneOff size={24} />
        </button>
      </div>
    </div>
  );
};

export default VideoControls;

